import { useEffect, useState } from "react";
import { Plus, PencilSimple, Trash, Buildings } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";

export default function Empresas() {
  const [companies, setCompanies] = useState([]);
  const [cDialog, setCDialog] = useState(false);
  const [cForm, setCForm] = useState({ name: "", code: "", active: true });
  const [cEditing, setCEditing] = useState(null);

  const load = () => api.get("/companies").then((res) => setCompanies(res.data));
  useEffect(() => { load(); }, []);

  const saveCompany = async () => {
    try {
      if (cEditing) await api.put(`/companies/${cEditing}`, cForm);
      else await api.post("/companies", cForm);
      toast.success("Empresa guardada");
      setCDialog(false);
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const removeCompany = async (c) => {
    if (!window.confirm(`¿Eliminar "${c.name}" y toda su información capturada?`)) return;
    await api.delete(`/companies/${c.id}`);
    toast.success("Empresa eliminada");
    load();
  };

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between gap-3">
        <p className="text-sm text-muted-foreground">
          Estructura multiempresa. En el dashboard puedes seleccionar una o varias empresas y consolidar su información.
        </p>
        <Button onClick={() => { setCForm({ name: "", code: "", active: true }); setCEditing(null); setCDialog(true); }} data-testid="new-company-button">
          <Plus size={18} className="mr-1" aria-hidden="true" /> Nueva empresa
        </Button>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {companies.map((c) => (
          <div key={c.id} className="flex items-center justify-between rounded-xl border border-border bg-card p-4" data-testid={`company-card-${c.code}`}>
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent">
                <Buildings weight="duotone" size={22} aria-hidden="true" />
              </div>
              <div>
                <p className="font-heading text-base font-semibold">{c.name}</p>
                <p className="font-mono text-xs text-muted-foreground">{c.code}</p>
              </div>
            </div>
            <div className="flex gap-1">
              <Button variant="ghost" size="icon" onClick={() => { setCForm({ name: c.name, code: c.code, active: c.active }); setCEditing(c.id); setCDialog(true); }} data-testid={`edit-company-${c.code}`}>
                <PencilSimple size={16} />
              </Button>
              <Button variant="ghost" size="icon" onClick={() => removeCompany(c)} data-testid={`delete-company-${c.code}`}>
                <Trash size={16} className="text-danger" />
              </Button>
            </div>
          </div>
        ))}
      </div>

      <Dialog open={cDialog} onOpenChange={setCDialog}>
        <DialogContent className="max-w-md" data-testid="company-dialog">
          <DialogHeader><DialogTitle className="font-heading">{cEditing ? "Editar empresa" : "Nueva empresa"}</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div className="space-y-1.5"><Label>Nombre</Label><Input value={cForm.name} onChange={(e) => setCForm({ ...cForm, name: e.target.value })} data-testid="company-name-input" /></div>
            <div className="space-y-1.5"><Label>Código</Label><Input value={cForm.code} onChange={(e) => setCForm({ ...cForm, code: e.target.value })} data-testid="company-code-input" /></div>
          </div>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setCDialog(false)}>Cancelar</Button>
            <Button onClick={saveCompany} data-testid="save-company-button">Guardar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
